import React from "react";
import { connect } from "react-redux";
import {
    removePaperFromUnassigned,
    updateSession,
    updateCalendarSession,
    changeSessionColor,
} from "../redux/actions";
import { API_URL } from "../constants";
import Paper from "./Paper";
import { PaperSessionHeadPanel } from "./PaperSessionHeadPanel";
import { BasicPaperSession } from "./BasicPaperSession";

class PaperSession extends BasicPaperSession {
    constructor(props) {
        super(props);

        this.dragOverSessionPanelColor = "#FFD19C";

        this.handleDrop = this.handleDrop.bind(this);
        this.handleDragOver = this.handleDragOver.bind(this);
        this.handleDragLeave = this.handleDragLeave.bind(this);
    }

    handleDragOver(event) {
        /*
         * The ondragover event specifies where the dragged data can be dropped.
         * By default, data/elements cannot be dropped in other elements. To allow a drop, we must prevent the default
         * handling of the element. This is done by calling the event.preventDefault() method.
         * */
        event.preventDefault();

        const { paperSession, sessionColors } = this.props;
        if (sessionColors[paperSession.id] !== this.dragOverSessionPanelColor) {
            this.props.changeSessionColor(
                paperSession.id,
                this.dragOverSessionPanelColor
            );
        }
    }

    handleDragLeave(event) {
        event.preventDefault();

        const { paperSession } = this.props;
        this.props.changeSessionColor(
            paperSession.id,
            paperSession.data.panel_color
        );
    }

    handleDrop(event) {
        event.preventDefault();
        const paperId = event.dataTransfer.getData("text");
        const { paperSession } = this.props;

        fetch(API_URL + "/paper-sessions/" + paperSession.id + "/add-paper", {
            method: "POST",
            headers: {
                Authorization: "Bearer " + this.props.user.api_token,
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            body: JSON.stringify({ paper_id: paperId }),
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText); // Will go to .catch
                return response.json();
            })
            .then((data) => {
                const { session, calendar } = data;
                /* If paper has been added succesfully to a session, then remove it from the list of available papers */
                this.props.removePaperFromUnassigned(paperId);
                /* Update session with the paper attached */
                this.props.updateSession(paperSession.id, session);
                /* Calendar duration might has changed, let's update the calendar information */
                if (calendar)
                    this.props.updateCalendarSession(calendar.id, calendar);

                //this.changePanelColor(panel_color);
            })
            .catch((error) => {
                this.props.changeSessionColor(
                    paperSession.id,
                    paperSession.data.panel_color
                );
                alert(error);
            });
    }

    render() {
        const { showPapers, paperSession, user, sessionColor } = this.props;
        const { papers, id, data } = paperSession;
        const keywordCounts = this.countKeywords(papers).slice(0, 4);
        const paperCount = papers.length;
        let session_duration = 0;
        for (let i = 0; i < paperCount; i++) {
            session_duration += papers[i].duration;
        }

        let paperSummary;
        if (showPapers) {
            paperSummary = (
                <div className="paperssession">
                    {papers.map((paper) => {
                        return (
                            <Paper
                                key={paper.id}
                                isInSession={true}
                                paper={paper}
                                user={user}
                            />
                        );
                    })}
                </div>
            );
        } else {
            paperSummary = (
                <div className="paperssummary" style={{ display: "block" }}>
                    {paperCount} paper(s) in this session
                </div>
            );
        }

        return (
            <div id={"s" + id} className="session" style={{ display: "block" }}>
                <div
                    className="panel panel-info"
                    onDragOver={this.handleDragOver}
                    onDragLeave={this.handleDragLeave}
                    onDrop={this.handleDrop}
                >
                    <PaperSessionHeadPanel
                        handleClick={this.props.togglePaperSummary}
                        data={data}
                        sessionColor={sessionColor}
                        keywordCounts={keywordCounts}
                        paperCount={paperCount}
                        showPaperCount={true}
                        sessionDuration={session_duration}
                        buttonClassName="pull-right glyphicon glyphicon-zoom-out pointer togglesession"
                        buttonStyle={{ fontSize: "1.5em" }}
                        sessionNameClassName="sessionname"
                    />
                    {paperSummary}
                    <div className="panel-footer">
                        <span
                            className="glyphicon glyphicon-trash pointer yesnomodal"
                            aria-hidden="true"
                            onClick={(e) => this.props.handleShow("Delete", id)}
                        ></span>{" "}
                        <span
                            className="glyphicon glyphicon-edit openmodal pointer"
                            aria-hidden="true"
                            onClick={(e) => this.props.handleShow("Edit", id)}
                        ></span>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { sessions } = state;
    return { sessionColors: sessions.sessionColors };
}

export default connect(mapStateToProps, {
    removePaperFromUnassigned,
    updateSession,
    updateCalendarSession,
    changeSessionColor,
})(PaperSession);
